import { useEffect } from "react";
import { PrintList } from "./PrintList";
import { PrintListMobile } from "./PrintListMobile";
import { useDispatch } from "react-redux";
import { getAllPrintFileFetch } from "../../features/action/fetchPrint";

const Print = () => {
  const dispatch = useDispatch();

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useEffect(() => {
    dispatch(getAllPrintFileFetch());
  }, [dispatch]);
  return isMobile ? <PrintListMobile /> : <PrintList />;
};

export default Print;
